/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'

import Header from './header'
import './layout.css'

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <main>{children}</main>
      <footer className="bg-gray-800">
        <div className="container mx-auto flex flex-col md:flex-row justify-between md:items-center px-6 py-10 text-white">
          <div className="flex flex-col md:flex-row md:items-center mb-2 md:mb-0">
            {/* <img
              className="w-40 mb-2 md:mb-0"
              src={require('../assets/logo/CodeShopNewCropeed-500x100.png')}
              alt="logo"
              style={{ filter: 'invert(0.4) grayscale(1)' }}
            /> */}
            <Link to="/" className="mb-2 md:mb-0 flex items-baseline text-3xl text-yellow-800 font-heading tracking-wide">
          <svg className='w-8 h-8 mr-2 fill-current text-yellow-800' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.996 511.996"><path d="M431.571 229.096c-2.968 0-5.279.174-8.827.49v35.628h.004c0 .076.04.151.039.228a45.185 45.185 0 018.809-.869c24.76 0 44.914 20.143 44.914 44.904s-20.139 44.903-44.899 44.903c-9.524 0-18.354-2.988-25.628-8.064-4.214 9.709-9.165 19.13-14.894 28.155-.671 1.057-1.375 2.087-2.065 3.13 12.358 7.754 26.955 12.258 42.59 12.258 44.323 0 80.382-36.059 80.382-80.382s-36.102-80.381-80.425-80.381z"/><path d="M444.057 417.622H314.639c51.954-31.93 84.457-90.187 84.457-152.409v-61.642H62.054v61.642c0 62.223 33.15 120.479 85.104 152.409H17.739C7.942 417.622 0 425.564 0 435.361S7.942 453.1 17.739 453.1h62.55c4.641 17.739 20.272 29.565 38.8 29.565h223.512c18.527 0 34.16-11.826 38.8-29.565h62.655c9.797 0 17.739-7.942 17.739-17.739s-7.941-17.739-17.738-17.739zM177.756 148.643l-8.7-6.992a13.803 13.803 0 01-5.188-11.014 13.8 13.8 0 015.484-10.869c12.012-9.13 19.112-23.016 19.48-38.1s-6.047-29.299-17.599-39.003c-7.501-6.301-18.691-5.328-24.993 2.174-6.301 7.501-5.328 18.691 2.174 24.993 4.45 3.737 5.012 8.478 4.952 10.972-.06 2.493-.854 7.201-5.48 10.718-12.18 9.256-19.285 23.338-19.49 38.635-.207 15.297 6.513 29.566 18.439 39.15l8.7 6.992a17.663 17.663 0 0011.101 3.912c5.19 0 10.335-2.267 13.839-6.627 6.134-7.638 4.918-18.803-2.719-24.941zM251.423 157.823l-10.205-8.2c-4.675-3.757-7.31-9.351-7.228-15.348.08-5.997 2.867-11.517 7.641-15.147 13.342-10.14 21.229-25.564 21.637-42.317s-6.716-32.544-19.547-43.322c-7.501-6.302-18.692-5.329-24.992 2.172-6.302 7.501-5.329 18.691 2.172 24.992a19.252 19.252 0 016.899 15.291 19.255 19.255 0 01-7.637 14.936c-13.528 10.28-21.419 25.922-21.649 42.913-.231 16.99 7.234 32.84 20.479 43.483l3.807 3.058 6.398 5.142a17.676 17.676 0 0011.102 3.912c5.19 0 10.335-2.267 13.839-6.627a17.711 17.711 0 001.618-2.426c4.186-7.426 2.53-16.997-4.334-22.512zM322.319 148.643l-8.7-6.992a13.803 13.803 0 01-5.188-11.014 13.8 13.8 0 015.484-10.869c12.012-9.13 19.112-23.016 19.48-38.1.368-15.084-6.047-29.299-17.599-39.003-7.502-6.301-18.692-5.328-24.993 2.174-6.301 7.501-5.328 18.691 2.174 24.993 4.45 3.737 5.012 8.478 4.952 10.972-.061 2.493-.854 7.201-5.48 10.718-12.18 9.256-19.285 23.338-19.49 38.635-.207 15.297 6.513 29.566 18.439 39.15l8.7 6.992a17.663 17.663 0 0011.101 3.912c5.19 0 10.335-2.267 13.839-6.627 6.134-7.638 4.918-18.803-2.719-24.941z"/></svg>
          CoffeeShop
          <span className='text-xs text-white font-body'> by Spmlifyd </span>
        </Link>
            <div className="md:ml-4">
              <span className="mr-4">All rights reserved</span>
              <span className="">Copyright © {new Date().getFullYear()}</span>
            </div>
          </div>
          <div className="">
            <span className="">Made with love by <a className='text-yellow-800 hover:text-yellow-700' href='https://simplifyd.tech'>Simplifyd.tech</a></span>
          </div>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
